// extracted by mini-css-extract-plugin
export default {"header":"SectionHeader_header__k-Moq","headingText":"SectionHeader_headingText__In0Qv"};